import { supabase } from "@/lib/supabase";
import type { Lead, LeadStatus } from "@/data/leads";

type LeadRow = {
  id: string;
  name: string;
  email: string;
  phone: string;
  vehicle: string;
  preferred_contact_method: string;
  enquiry_type: string;
  message: string;
  created_at: string;
  status: LeadStatus;
};

export async function getLeads(): Promise<Lead[]> {
  const { data, error } = await supabase.from("contact_enquiries").select("*").order("created_at", { ascending: false });
  if (error) throw error;
  return ((data || []) as LeadRow[]).map((row) => ({
    id: row.id,
    name: row.name,
    initials: row.name.split(/\s+/).filter(Boolean).slice(0, 2).map((part) => part[0].toUpperCase()).join(""),
    email: row.email,
    phone: row.phone,
    vehicle: row.vehicle || row.enquiry_type || "General enquiry",
    method: row.preferred_contact_method === "WhatsApp" ? "WhatsApp" : row.preferred_contact_method === "Phone call" ? "Phone" : row.preferred_contact_method === "Email" ? "Email" : "Form",
    message: row.message,
    date: new Date(row.created_at).toLocaleDateString("en-ZA", { day: "2-digit", month: "short", year: "numeric" }),
    status: row.status,
  }));
}

export async function updateLeadStatus(id: string, status: LeadStatus): Promise<void> {
  const { error } = await supabase.from("contact_enquiries").update({ status, updated_at: new Date().toISOString() }).eq("id", id);
  if (error) throw error;
}

